import { Link, NavLink } from "react-router-dom";
import { Icon } from "./Icon";

export function SiteHeader({ quiet = false }: { quiet?: boolean }) {
  return (
    <header className={`site-header${quiet ? " site-header--quiet" : ""}`}>
      <Link className="site-brand" to="/" aria-label="RSM Consulting home">
        <span className="site-brand__mark">RSM</span>
        <span className="site-brand__name">Consulting</span>
      </Link>
      <nav className="site-nav" aria-label="Primary navigation">
        <NavLink to="/#practice">Practice</NavLink>
        <Link className="site-nav__primary" to="/book/shahil-30">
          Book a call <Icon name="arrow" />
        </Link>
      </nav>
    </header>
  );
}
